import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Purpose} from '../purpose';
import {PageableResponse} from '../../entity';


@Injectable()
export class PurposesService {

    constructor(private _http: HttpClient) {
    }

    getPurposes(): Observable<Purpose[]> {
        return this._http.get<PageableResponse<Purpose>>(`api/client/dictionary/purposes`)
            .map(res => res.records);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/purposes.service.ts